import $ from "jquery";

function scrollEvent()
{

    if ($('.scrolling').length) {
        var element = document.querySelector('.scrolling');
        const height = element.offsetHeight;

        console.log(height)

        var scrollingDistance = $('.scrolling').offset().top - 50,
        calculatorCta = $('.scrolling_endline').offset().top - (height + 200),
        $window = $(window);

        $window.scroll(function() {

            if ( $window.scrollTop() >= scrollingDistance ) {
                $('.scrolling').addClass('fixed');
                $('.scrolling').removeClass('end');
            } else {
                $('.scrolling').removeClass('fixed');
            }
            
            if ( $window.scrollTop() >= calculatorCta ) {
                $('.scrolling').addClass('end');
                $('.scrolling').removeClass('fixed');
            }
        });
    }
}

function scrollItemsClick()
{
    var clickableElements = document.querySelectorAll('.scrollitems');
    var previousClickedElement = null;

    clickableElements.forEach(function(element) {
        element.addEventListener('click', function() {
            if (previousClickedElement) {
                previousClickedElement.style.color = '';
            }

            element.style.color = '#FA9600';
        
            previousClickedElement = element;
        });
    });
}

function shareOnFacebook() 
{
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), 'facebook-share-dialog', 'width=626,height=436');
}

function shareOnTwitter() 
{
    window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href), 'twitter-share-dialog', 'width=626,height=436');
}

function shareOnLinkedIn() 
{
    window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(window.location.href), 'linkedin-share-dialog', 'width=626,height=436');
}

function copyPageLink() 
{
    var copyText = document.createElement('textarea');
    copyText.value = window.location.href;
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    alert('Link copied to clipboard!');
}


document.addEventListener('DOMContentLoaded', function() {
    scrollEvent();
    scrollItemsClick();

    var shareFacebook = document.querySelector('#shareFacebook');
    if (shareFacebook) {
        document.getElementById('shareFacebook').addEventListener('click', shareOnFacebook);
        document.getElementById('shareTwitter').addEventListener('click', shareOnTwitter);
        document.getElementById('shareLinkedIn').addEventListener('click', shareOnLinkedIn);
        document.getElementById('copyLink').addEventListener('click', copyPageLink);
    }
});